import { animate, stagger, splitText, onScroll } from 'animejs';

const IMAGE_SELECTOR = [
    'img',
    '.wp-block-image',
];
const TEXT_SELECTOR = [
    '.wp-block-heading',
    '.wp-block-paragraph',
    '.wp-block-list',
].join(',');

document.addEventListener('DOMContentLoaded', () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.from(document.querySelectorAll(IMAGE_SELECTOR)).forEach((img) => {
        if (img.closest('[data-no-reveal]')) return;

        img.style.clipPath = 'inset(0 0 100% 0)';

        if (prefersReducedMotion) {
            img.style.clipPath = 'none';
            return;
        }

        const duration = Number(img.getAttribute('data-reveal-duration')) || 560;
        const delay = Number(img.getAttribute('data-reveal-delay')) || 0;

        animate(img, {
            clipPath: ['inset(0 0 100% 0)', 'inset(0 0 0% 0)'],
            duration,
            delay,
            easing: 'easeOutCubic',
            autoplay: onScroll({
                enter: 'bottom-=40% top',
            }),
        });
    });

    // Text: headings get word-by-word, others slide-up
    Array.from(document.querySelectorAll(TEXT_SELECTOR)).forEach((el) => {
        if (el.closest('[data-no-reveal]')) return;

        if (prefersReducedMotion) {
            animate(el, {
                opacity: [0, 1],
                duration: 560,
                easing: 'linear',
                autoplay: onScroll({
                    target: el,
                    enter: 'bottom-=10% top',
                    leave: 'top+=70% bottom',
                    sync: true
                })
            });
            return;
        }

        // Headings: H1/H2 word-by-word
        if ((el.tagName === 'H1' || el.tagName === 'H2')) {
            try {
                const { words } = splitText(el, { words: { wrap: 'clip' } });
                const duration = Number(el.getAttribute('data-reveal-duration')) || 450;
                const delayStep = Number(el.getAttribute('data-reveal-delay')) || 50;

                animate(words, {
                    y: [{ to: ['100%', '0%'] }],
                    opacity: [{ to: [0, 1] }],
                    duration,
                    easing: 'easeOutCubic',
                    delay: stagger(delayStep),
                    autoplay: onScroll({
                        target: el,
                        enter: 'bottom-=10% top',
                        leave: 'top+=70% bottom',
                        sync: true
                    })
                });
            } catch (err) {
                // fallback: simple slide
                animate(el, {
                    translateX: [-12, 0],
                    opacity: [0, 1],
                    duration: 560,
                    easing: 'easeOutCubic',
                    autoplay: onScroll({
                        target: el,
                        enter: 'bottom-=10% top',
                        leave: 'top+=70% bottom',
                        sync: true
                    })
                });
            }
        } else {
            const duration = Number(el.getAttribute('data-reveal-duration')) || 560;
            const delay = Number(el.getAttribute('data-reveal-delay')) || 0;
            animate(el, {
                translateY: [24, 0],
                opacity: [0, 1],
                duration,
                delay,
                easing: 'easeOutCubic',
                autoplay: onScroll({
                    target: el,
                    enter: 'bottom-=10% top',
                    leave: 'top+=70% bottom',
                    sync: true
                })
            });
        }
    });
});
